var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronRightCarouselSharedCh = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 16,
  viewBox: "0 0 10 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.0600586 14.12L6.16673 8L0.0600586 1.88L1.94006 0L9.94006 8L1.94006 16L0.0600586 14.12Z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8cGF0aCBkPSJNMC4wNjAwNTg2IDE0LjEyTDYuMTY2NzMgOEwwLjA2MDA1ODYgMS44OEwxLjk0MDA2IDBMOS45NDAwNiA4TDEuOTQwMDYgMTZMMC4wNjAwNTg2IDE0LjEyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+DQo8L3N2Zz4NCg==";
export { SvgChevronRightCarouselSharedCh as ReactComponent };